import { render, staticRenderFns } from "./product-row.vue?vue&type=template&id=63e9f562&"
import script from "./product-row.vue?vue&type=script&lang=ts&"
export * from "./product-row.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports